import { GraphBuilder } from '../graph/builder';
import { ComponentDef } from './types';

export const imageTokenizerComponent: ComponentDef = {
  id: 'image-tokenizer',
  name: 'Image Tokenizer',
  description: 'Encode image patches into a discrete vocabulary of visual tokens.',
  category: 'multimodal',
  params: [
    { name: 'n_patches', label: 'Image patches', type: 'number', default: 256, min: 1, max: 1024, step: 1 },
    { name: 'd_model', label: 'Model dimension', type: 'number', default: 512, min: 64, max: 4096, step: 64 },
    { name: 'vocab_size', label: 'Visual vocabulary', type: 'number', default: 8192, min: 256, max: 65536, step: 256 }
  ],
  buildGraph: (params) => {
    const n_patches = Number(params.n_patches);
    const d_model = Number(params.d_model);
    const vocab_size = Number(params.vocab_size);

    const g = new GraphBuilder();
    g.input('image', [n_patches, d_model]);

    g.conv('patchify', 'image', [n_patches, d_model], 'patch');
    g.linear('codes', 'patchify', [d_model, vocab_size]);
    g.quantize('discrete', 'codes', [n_patches], 8);
    g.embedding('tokens', 'discrete', [vocab_size, d_model]);
    g.output('out', 'tokens');
    return g.build();
  }
};
